module.exports = __webpack_public_path__ + "static/gira-sans-regular-966e1466db3329b145abc07d6cde9386.woff";